import { Link } from 'react-router-dom';
import SectionHeading from '../components/SectionHeading';
import CTAButton      from '../components/CTAButton';
import { HOW_WE_WORK, WHAT_WE_STAND_FOR } from '../constant/data';
function About() {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb-nav">
            <Link to="/">Home</Link>
            <span>/</span>
            About
          </div>
          <h1>We're Salama Consult</h1>
          <p>
            A software company based in Kampala. We build and run systems for organisations
            that need reliable technology and long-term support.
          </p>
        </div>
      </section>

      {/* Who We Are */}
      <section className="section-corporate">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <SectionHeading label="Who We Are">
                Built to solve real problems
              </SectionHeading>
              <p style={{ color: 'var(--ink-2)', lineHeight: '1.8', marginBottom: '1rem', fontSize: '0.95rem' }}>
                Salama Consult is a technology company that designs, builds, and runs management systems
                for organisations that can't afford things to go wrong. We work with government agencies,
                NGOs, financial institutions, and private enterprises.
              </p>
              <p style={{ color: 'var(--ink-2)', lineHeight: '1.8', marginBottom: '1rem', fontSize: '0.95rem' }}>
                We've been doing this for over 10 years. In that time we've delivered custom software,
                mobile apps, enterprise systems, web hosting for 200+ businesses, domain management,
                and website design for clients across Uganda and East Africa. They're all still running.
              </p>
              <p style={{ color: 'var(--ink-2)', lineHeight: '1.8', marginBottom: '1.5rem', fontSize: '0.95rem' }}>
                We're based in Kampala and most of our work is in Uganda and East Africa — though the
                systems we build are designed to work anywhere.
              </p>
              <div className="d-flex flex-wrap gap-3">
                <CTAButton type="gold" to="/contact">Get in Touch</CTAButton>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How We Work */}
      <section className="section-corporate" style={{ background: 'var(--surface-2)', borderTop: '1px solid var(--border-1)', borderBottom: '1px solid var(--border-1)' }}>
        <div className="container">
          <SectionHeading
            align="center"
            label="How We Work"
            subtitle="A straightforward process that we've refined over many projects."
          >
            What working with us looks like
          </SectionHeading>

          <div className="row g-4">
            {HOW_WE_WORK.map(a => (
              <div className="col-md-4 col-6" key={a.title}>
                <div className="value-card">
                  <div className="value-icon"><i className={a.icon} /></div>
                  <h5>{a.title}</h5>
                  <p>{a.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values + Capabilities */}
      <section className="section-corporate">
        <div className="container">
          <div className="row align-items-start g-5">
            <div className="col-lg-6">
              <SectionHeading label="What We Stand For">
                Our principles
              </SectionHeading>
              <div className="mt-3">
                {WHAT_WE_STAND_FOR.map(p => (
                  <div className="principle-item" key={p.title}>
                    <div className="principle-check"><i className="fas fa-check" /></div>
                    <div>
                      <h6>{p.title}</h6>
                      <p>{p.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-5 offset-lg-1">
              <div className="capabilities-box">
                <h4>What we can help with</h4>
                <div className="row g-2">
                  {[
                    'Software development',
                    'Mobile app development',
                    'System development',
                    'Web hosting',
                    'Domain registration',
                    'Website designing',
                    'IT consulting',
                    'Training & capacity building',
                    'Ongoing support & SLAs',
                    'Digital transformation advisory',
                  ].map(c => (
                    <div className="col-6" key={c}>
                      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', fontSize: '0.83rem', color: 'var(--ink-2)', padding: '0.2rem 0' }}>
                        <i className="fas fa-check" style={{ color: 'var(--ink-1)', fontSize: '0.6rem', marginTop: '0.3rem', flexShrink: 0 }} />
                        {c}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="section-corporate" style={{ background: 'var(--surface-2)', borderTop: '1px solid var(--border-1)', borderBottom: '1px solid var(--border-1)' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <SectionHeading label="Our Mission">
                Helping organisations run with confidence
              </SectionHeading>
              <p style={{ color: 'var(--ink-2)', lineHeight: '1.8', marginBottom: '1.25rem', fontSize: '0.95rem' }}>
                A lot of organisations in Uganda and East Africa are still running critical operations
                on spreadsheets, paper files, or aging software. We exist to help them move to something better —
                without the complexity or cost that usually comes with that.
              </p>
              <p style={{ color: 'var(--ink-2)', lineHeight: '1.8', fontSize: '0.95rem', marginBottom: '1.5rem' }}>
                Whether you need a custom mobile app, a hosted website, a domain for your business,
                or a full enterprise system — we have the experience to do it properly and the
                commitment to stay involved long after launch.
              </p>
              <CTAButton type="gold" to="/contact">Talk to Us</CTAButton>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container text-center position-relative">
          <h2>Want to know more?</h2>
          <p>
            Send us a message and we'll get back to you within 24 hours.
          </p>
          <CTAButton type="gold" to="/contact">Get in Touch</CTAButton>
        </div>
      </section>
    </>
  );
}

export default About;
